export default __webpack_public_path__ + "static/media/screenshot_step1_4b_purple.df0f1544.png";